export const LOCATION_OPTIONS = [
  { label: "Tent (Meals, Registration)", value: "Tent" },
  {
    label: "1st Floor IDEAS Lab (Hardware Hub)",
    value: "1st Floor IDEAS Lab",
  },
  {
    label:
      "3rd Floor Innovation Wing (2 large classrooms, ~50 hackers each during workshops)",
    value: "3rd Floor Innovation Wing",
  },
  {
    label:
      "4th Floor Exploration Wing (talk talk lecture hall, ~85 hackers each during tech talks)",
    value: "4th Floor ",
  },
  {
    label:
      "5th Floor Momentum Wing (2 large classrooms, ~50 hackers each during workshops)",
    value: "5th Floor",
  },
  {
    label: "Design Bay (Slient Disco, Hacky Hour)",
    value: "Design Bay",
  },
];
